import APICom from "./APICom";
import moment from 'moment';
import {SetCombineData} from "../../features/common/combinedataSlice";

class CommonFunctions {
    
    static async checkAutoRouting(TempAff, _req_date, GlobalASCSData) {
        let _result = GlobalASCSData.filter((v) => String(v.AffiliateID) == String(TempAff));
        let isDateInSevenDays = true;
        try {
            let _today_date = moment();
            _today_date = _today_date.add(6, 'days');
            let _requested_date = moment(_req_date);
            if (_requested_date.isSameOrBefore(_today_date.add(6, 'days'), 'day')) {
                isDateInSevenDays = true;
            } else {
                isDateInSevenDays = false;
            }
        } catch (e) {
            console.log("error isDateInSevenDays :" + e);
        }
        let bStopped = false;
        //TempAff="28";
        if (isDateInSevenDays) {
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ARBProcessStatus?AffiliateID=" + TempAff + "&ReqDate=" + "1/1/1900", "get", { "Content-Type": "application/json" }, null, null);
            let data = response.data;
            let _requested_date = moment(_req_date);
            for (let i = 0; i < data.length; i++) {
                if (_requested_date.isSame(data[i].dtServiceDate, 'day')) {
                    bStopped = true;
                    break;
                }
            }
        }
        let returnResult = false;
        if (_result.length > 0 && _result[0].bAutoRoutingEnabled === true && isDateInSevenDays === true && bStopped === true) {
            let response =  await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ARBProcessStatus?AffiliateID=" + TempAff + "&ReqDate=" + _req_date, "get", { "Content-Type": "application/json" }, null, null);
            let data = response.data;
            if (data.length > 0 && data[0].iPauseAutoRouting === 0) {
                returnResult = true;
            }
            else {
                returnResult = false;
            }
        }
        else {
            returnResult = false;
        }
        return returnResult;
    }
    static ParseFormatADate(datetimeobj){
        // Input date string
        let dateString = datetimeobj;

        // Split the string into date and time parts
        let [datePart, timePart] = dateString.split(' ');

        // Split the date part into day, month, and year
        let [month, day, year] = datePart.split('/');

        // Split the time part into hours, minutes, and AM/PM
        let [time, period] = timePart.split(/([0-9]+:[0-9]+)([A-Za-z]+)/).filter(Boolean);

        // Convert 12-hour time to 24-hour time
        let [hours, minutes] = time.split(':');
        if (period.toUpperCase() === 'PM') {
            hours = (parseInt(hours, 10) % 12) + 12;
        }

        // Create a new Date object
        return new Date(year, month - 1, day, hours, minutes);
    }
    static isDateWithin30Minutes(date){
        // Get the current date and time
        const currentDate = new Date();
      
        // Calculate the difference in milliseconds between the given date and the current date
        const timeDifference = date.getTime() - currentDate.getTime();
      
        // Convert the time difference to minutes
        const minutesDifference = timeDifference / (1000 * 60);
      
        // Check if the absolute value of the minutes difference is less than or equal to 30
        return Math.abs(minutesDifference) <= 30;
    }
    static isDateWithinFuture30Minutes(date){
        // Get the current date and time
        const currentDate = new Date();
      
        // Calculate the difference in milliseconds between the given date and the current date
        const timeDifference = date.getTime() - currentDate.getTime();
      
        // Convert the time difference to minutes
        const minutesDifference = timeDifference / (1000 * 60);
      
        // Check if the absolute value of the minutes difference is less than or equal to 30
        return minutesDifference <= 30;
    }
    static async SaveRBSStatus (iPauseAutoRouting, dtServiceDate, affilateId, user_id, iActionSource = 0) {
        try {
/*
        var myData = "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + user_id;
        sessionStorage.setItem('ARBProcessStatus', myData);
        */
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + user_id, "post", { "Content-Type": "application/json" }, null, null);
            
        } catch (ex) {
            console.log(ex);
        }
    }

    static PopulateCombineData = async(e) => {
        let response = ""
        try {
            let vUserAssignedAffiliates = "-1";
            response = await APICom.fetchData("AspDotNetCoreURL", "CombinedData/GetCombinedDataByAffiliateIDs?vAffiliateIds=" + vUserAssignedAffiliates, "get", {}, {});
            response = JSON.parse(response.data);
            return response;
        }
        catch(e){console.log(e);}
        return response;
    };

    static PopulateGridColorData = async(iUserAffiliateID, dispatch) => {
        try {
            let data = {
                "iATSPID": String(iUserAffiliateID)
            }
            let responseT = await APICom.fetchData("", "TripActions/GetServiceRequestColorCodes", "post", {"Content-Type": "application/json"}, data, null);
            let api_data = responseT.data.data ? responseT.data.data : []
            if (api_data?.length) {
                if (api_data.length === 3) {
                    dispatch(SetCombineData({data: api_data, name: "DispatchGridColorsData"}));
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    static CreateElement = (tag, options = {}) => {
        try{
            const element = document.createElement(tag);
        
            //set attributes i.e. id, type, title, etc...
            if(options.attributes) {
                Object.entries(options.attributes).forEach(([key, value]) => {
                    if(key === 'checked' || key === 'disabled' || key === 'selected' || key === 'readonly'){
                        element[key] = value;
                    }
                    else {
                        element.setAttribute(key, value);
                    }
                });
            }

            //Set important CSS styles i.e. font-size, etc...
            if(options.properties && options.properties.length > 0) {
                options.properties.forEach(({style, value}) => {
                    element.style.setProperty(style, value, 'important');
                });
            }
            
            // Set styles...
            if(options.styles){
                Object.assign(element.style, options.styles);
            }
    
            // Add class names...
            if(options.classes){
                element.classList.add(...options.classes);
            }
    
            // Set inner HTML or text
            if(options.text){
                element.textContent = options.text;
            }

            if(options.html){
                element.innerHTML = options.html;
            }

            //Add children...
            if(options.children) {
                options.children.forEach((child) => {
                    element.appendChild(child);
                });
            }

            return element;
        }
        catch(err){console.log(err);}
    };

    
    static GenerateUUID = () => {
        return 'xxxx-xxxx-xxxx'.replace(/[x]/g, () =>
        ((Math.random() * 16) | 0).toString(16)
    );
  };
};

export default CommonFunctions;